import React from 'react';
import { X, Plus, Minus, ShoppingBag, CreditCard, ArrowRight } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { useNavigate } from 'react-router-dom';

const CartNew = () => {
  const {
    cartItems,
    isCartOpen,
    setIsCartOpen,
    appliedCoupon,
    updateQuantity,
    removeFromCart,
    getCartTotal,
    getCartDiscount,
    getFinalTotal,
    getCartItemCount,
    removeCoupon
  } = useCart();
  
  console.log('🛒 CartNew render - cartItems:', cartItems);
  console.log('🛒 CartNew render - getCartItemCount():', getCartItemCount());
  console.log('🛒 CartNew render - getCartTotal():', getCartTotal());
  
  const navigate = useNavigate();

  const handleCheckout = () => {
    setIsCartOpen(false);
    navigate('/checkout');
  };

  const CartItem = ({ item }) => (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '12px',
      marginBottom: '8px',
      border: '1px solid #e5e7eb',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        {/* Food Image */}
        <div style={{
          position: 'relative',
          width: '50px',
          height: '50px',
          borderRadius: '8px',
          overflow: 'hidden',
          flexShrink: 0
        }}>
          <img
            src={item.image || `https://via.placeholder.com/50x50/ff6b35/ffffff?text=${encodeURIComponent(item.name.charAt(0))}`}
            alt={item.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
            onError={(e) => {
              e.target.src = `https://via.placeholder.com/50x50/ff6b35/ffffff?text=${encodeURIComponent(item.name.charAt(0))}`;
            }}
          />
        </div>

        {/* Item Details */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <h3 style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#1f2937',
            margin: '0 0 4px 0',
            lineHeight: '1.3',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          }}>
            {item.name}
          </h3>
          <p style={{
            fontSize: '12px',
            color: '#6b7280',
            margin: '0 0 8px 0'
          }}>
            {item.portion} • ₹{Number(item.price) || 0}
          </p>
          
          {/* Quantity Controls */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <button
              onClick={() => updateQuantity(item.id, item.portion, item.quantity - 1)}
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '6px',
                border: '1px solid #e5e7eb',
                backgroundColor: 'white',
                color: '#6b7280',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              <Minus style={{ width: '14px', height: '14px' }} />
            </button>
            
            <span style={{
              fontSize: '14px',
              fontWeight: '600',
              color: '#1f2937',
              minWidth: '20px',
              textAlign: 'center'
            }}>
              {item.quantity}
            </span>
            
            <button
              onClick={() => updateQuantity(item.id, item.portion, item.quantity + 1)}
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '6px',
                border: '1px solid #e5e7eb',
                backgroundColor: 'white',
                color: '#6b7280',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              <Plus style={{ width: '14px', height: '14px' }} />
            </button>
            
            <button
              onClick={() => removeFromCart(item.id, item.portion)}
              style={{
                marginLeft: 'auto',
                padding: '4px',
                backgroundColor: '#fef2f2',
                color: '#ef4444',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <X style={{ width: '14px', height: '14px' }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  if (!isCartOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        width: '100%',
        maxHeight: '80vh',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.1)'
      }}>
        {/* Header */}
        <div style={{
          padding: '16px 20px',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <h2 style={{
            fontSize: '18px',
            fontWeight: '700',
            color: '#1f2937',
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <ShoppingBag style={{ width: '20px', height: '20px', color: '#ff6b35' }} />
            Cart ({getCartItemCount()})
          </h2>
          <button
            onClick={() => setIsCartOpen(false)}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: '#f3f4f6',
              color: '#6b7280',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <X style={{ width: '18px', height: '18px' }} />
          </button>
        </div>


        {/* Cart Items */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '16px 20px'
        }}>
          {cartItems.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              color: '#6b7280'
            }}>
              <ShoppingBag style={{
                width: '48px',
                height: '48px',
                margin: '0 auto 16px',
                color: '#d1d5db'
              }} />
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#374151',
                margin: '0 0 8px 0'
              }}>
                Your cart is empty
              </h3>
              <p style={{
                fontSize: '14px',
                margin: 0
              }}>
                Add some delicious food to get started!
              </p>
            </div>
          ) : (
            <div>
              {cartItems.map(item => (
                <CartItem key={`${item.id}-${item.portion}`} item={item} />
              ))}
            </div>
          )}
        </div>

        {/* Footer - Only show if cart has items */}
        {cartItems.length > 0 && (
          <div style={{
            padding: '16px 20px',
            borderTop: '1px solid #e5e7eb',
            backgroundColor: '#f8f9fa'
          }}>
            {/* Applied Coupon */}
            {appliedCoupon && (
              <div style={{
                backgroundColor: '#f0fdf4',
                border: '1px solid #bbf7d0',
                borderRadius: '8px',
                padding: '8px 12px',
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <div style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: '#22c55e'
                  }} />
                  <span style={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#166534'
                  }}>
                    {appliedCoupon.code} applied
                  </span>
                </div>
                <button
                  onClick={removeCoupon}
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: '#ef4444',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '600'
                  }}
                >
                  Remove
                </button>
              </div>
            )}

            {/* Order Summary */}
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '16px'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <span style={{
                  fontSize: '14px',
                  color: '#6b7280'
                }}>
                  Subtotal ({getCartItemCount()} items)
                </span>
                <span style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#1f2937'
                }}>
                  ₹{Number(getCartTotal()) || 0}
                </span>
              </div>
              
              {appliedCoupon && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '8px'
                }}>
                  <span style={{
                    fontSize: '14px',
                    color: '#22c55e'
                  }}>
                    Discount ({appliedCoupon.type === 'percentage' ? `${appliedCoupon.value}%` : `₹${appliedCoupon.value}`})
                  </span>
                  <span style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#22c55e'
                  }}>
                    -₹{Number(getCartDiscount()) || 0}
                  </span>
                </div>
              )}
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: '8px',
                borderTop: '1px solid #e5e7eb'
              }}>
                <span style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#1f2937'
                }}>
                  Total
                </span>
                <span style={{
                  fontSize: '18px',
                  fontWeight: '800',
                  color: '#ff6b35'
                }}>
                  ₹{Number(getFinalTotal()) || 0}
                </span>
              </div>
            </div>

            {/* Checkout Button */}
            <button
              onClick={handleCheckout}
              style={{
                width: '100%',
                padding: '16px',
                backgroundColor: '#ff6b35',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '700',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e05a2e'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ff6b35'}
            >
              <CreditCard style={{ width: '20px', height: '20px' }} />
              Proceed to Checkout
              <ArrowRight style={{ width: '20px', height: '20px' }} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartNew;